import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/home/Home.vue";
import Investigation from "../views/investigation/Investigation.vue";
import TrainScore from "../views/trainScore/TrainScore.vue";
import { Message } from "element-ui";
import store from "../store/index";

Vue.use(VueRouter);

const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err);
};

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      needLogin: true,
      navIndex: "0"
    }
  },
  {
    path: "/home",
    name: "HomePage",
    component: Home,
    meta: {
      needLogin: true,
      navIndex: "0"
    }
  },
  {
    path: "/examsList",
    name: "ExamsList",
    component: () => import("../views/exams/ExamsList.vue"),
    meta: {
      needLogin: true,
      navIndex: "1"
    }
  },
  {
    path: "/examsListzx",
    name: "ExamsListZX",
    component: () => import("../views/exams/ExamsList.vue"),
    meta: {
      needLogin: true,
      navIndex: "2"
    }
  },
  {
    path: "/examsListzt",
    name: "ExamsListZT",
    component: () => import("../views/exams/ExamsList.vue"),
    meta: {
      needLogin: true,
      navIndex: "3"
    }
  },
  {
    path: "/examsListsz",
    name: "ExamsListSZ",
    component: () => import("../views/exams/ExamsList.vue"),
    meta: {
      needLogin: true,
      navIndex: "4"
    }
  },
  {
    path: "/studyPage",
    name: "StudyPage",
    component: () => import("../views/study/StudyPage.vue"),
    meta: {
      needLogin: true,
      navIndex: "6"
    }
  },
  {
    path: "/choicePracticeBase",
    name: "ChoicePracticeBase",
    component: () =>
      import("../views/choicePracticeBase/ChoicePracticeBase.vue"),
    meta: {
      needLogin: true,
      isLoginPage: false,
      navIndex: "6"
    }
  },
  {
    path: "/investigation",
    name: "Investigation",
    component: Investigation,
    meta: {
      needLogin: true,
      navIndex: "6"
    }
  },
  {
    path: "/trainScore",
    name: "TrainScore",
    component: TrainScore,
    meta: {
      needLogin: true,
      navIndex: "6"
    }
  },
  {
    path: "/mine",
    name: "Mine",
    component: () => import("../views/mine/Mine.vue"),
    meta: {
      needLogin: true,
      navIndex: "7"
    }
  },
  {
    path: "/expert",
    name: "Expert",
    component: () => import("../views/expert/Expert.vue"),
    meta: {
      needLogin: true,
      navIndex: "5"
    }
  },
  {
    path: "/expertCertification",
    name: "ExpertCertification",
    component: () => import("../views/expert/ExpertCertification.vue"),
    meta: {
      needLogin: true,
      navIndex: "5"
    }
  },
  {
    path: "/evaluationRecord",
    name: "EvaluationRecord",
    component: () => import("../views/evaluationRecord/EvaluationRecord.vue"),
    meta: {
      needLogin: true,
      isLoginPage: false,
      navIndex: "5"
    }
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/login/Login.vue"),
    meta: {
      needLogin: false,
      isLoginPage: true,
      navIndex: "0"
    }
  },
  {
    path: "/news",
    name: "News",
    component: () => import("../views/news/News.vue"),
    meta: {
      needLogin: false,
      isLoginPage: false,
      navIndex: "0"
    }
  },
  {
    path: "/trainNotice",
    name: "TrainNotice",
    component: () => import("@/views/trainNotice/TrainNotice.vue"),
    meta: {
      needLogin: true,
      isLoginPage: false,
      navIndex: "0"
    }
  },
  {
    path: "/forget",
    name: "Forget",
    component: () => import("../views/login/Forget.vue"),
    meta: {
      needLogin: false,
      isLoginPage: true,
      navIndex: "0"
    }
  },
  {
    path: "/reg",
    name: "Reg",
    component: () => import("../views/login/Reg.vue"),
    meta: {
      needLogin: false,
      isLoginPage: true,
      navIndex: "0"
    }
  },
  {
    path: "/regExam",
    name: "RegExam",
    component: () => import("../views/home/RegExam.vue"),
    meta: {
      needLogin: true,
      isLoginPage: false,
      navIndex: "0"
    }
  },
  {
    path: "/registrationDetails",
    name: "RegistrationDetails",
    component: () =>
      import("../views/registrationDetails/RegistrationDetails.vue"),
    meta: {
      needLogin: true,
      isLoginPage: false,
      navIndex: "0"
    }
  },
  {
    path: "/registrationApply",
    name: "RegistrationApply",
    component: () =>
      import("../views/registrationDetails/RegistrationApply.vue"),
    meta: {
      needLogin: true,
      isLoginPage: false,
      navIndex: "0"
    }
  },
  {
    path: "/regExam4wx", // 给微信审核用的临时地址
    name: "ExamInfo",
    component: () => import("../views/home/RegExam.vue"),
    meta: {
      needLogin: false,
      isLoginPage: false,
      navIndex: "0"
    }
  },
  {
    path: "/realName",
    name: "RealName",
    component: () => import("../views/realName/RealName.vue"),
    meta: {
      needLogin: true,
      isLoginPage: false,
      navIndex: "100"
    }
  },
  {
    path: "/examInfo",
    name: "ExamInfo",
    component: () => import("../views/exam/ExamInfo.vue"),
    meta: {
      needLogin: true,
      isLoginPage: false,
      navIndex: "6"
    }
  },
  {
    path: "/appIntro",
    name: "AppIntro",
    component: () => import("../views/intro/AppIntro.vue"),
    meta: {
      needLogin: false,
      isLoginPage: false,
      navIndex: "0"
    }
  },
  {
    path: "/formalExam",
    name: "FormalExam",
    component: () => import("../views/exam/FormalExam.vue"),
    meta: {
      needLogin: true,
      isLoginPage: false,
      keepAlive: true,
      navIndex: "6"
    }
  },
  {
    path: "/practice",
    name: "Practice",
    component: () => import("../views/practice/practiceLib.vue"),
    meta: {
      needLogin: true,
      isLoginPage: false,
      navIndex: "6"
    }
  },
  {
    path: "/practiceLibExam",
    name: "PracticeLibExam",
    component: () => import("../views/practice/PracticeLibExam.vue"),
    meta: {
      needLogin: true,
      isLoginPage: false,
      navIndex: "6"
    }
  },
  {
    path: "/mockExamLib",
    name: "MockExamLib",
    component: () => import("../views/mockExam/MockExamLib.vue"),
    meta: {
      needLogin: true,
      isLoginPage: false,
      navIndex: "6"
    }
  },
  {
    path: "/mockExam",
    name: "MockExam",
    component: () => import("../views/mockExam/MockExam.vue"),
    meta: {
      needLogin: true,
      isLoginPage: false,
      navIndex: "6",
      keepAlive: true
    }
  },
  {
    path: "/mockExamAnalysis",
    name: "MockExamAnalysis",
    component: () => import("../views/mockExam/MockExamAnalysis.vue"),
    meta: {
      needLogin: true,
      isLoginPage: false,
      navIndex: "6"
    }
  },
  {
    path: "/courseList",
    name: "CourseList",
    component: () => import("../views/course/CourseList.vue"),
    meta: {
      needLogin: true,
      isLoginPage: false,
      navIndex: "6",
      keepAlive: true
    }
  },
  {
    path: "/courseContent",
    name: "CourseContent",
    component: () => import("../views/course/CourseContent.vue"),
    meta: {
      needLogin: true,
      isLoginPage: false,
      navIndex: "6"
    }
  },
  {
    path: "/videoCourseList",
    name: "VideoCourseList",
    component: () => import("../views/videoCourse/VideoCourseList.vue"),
    meta: {
      needLogin: true,
      isLoginPage: false,
      navIndex: "6"
    }
  },
  {
    path: "/liveCourseList",
    name: "LiveCourseList",
    component: () => import("@/views/liveCourse/LiveCourseList.vue"),
    meta: {
      needLogin: true,
      isLoginPage: false,
      navIndex: "6"
    }
  },
  {
    path: "/videoCourse",
    name: "VideoCourse",
    component: () => import("../views/videoCourse/VideoCourse.vue"),
    meta: {
      needLogin: true,
      isLoginPage: false,
      navIndex: "6"
    }
  },
  {
    path: "/collectionList",
    name: "CollectionList",
    component: () => import("../views/collection/Collection.vue"),
    meta: {
      needLogin: true,
      isLoginPage: false,
      navIndex: "100"
    }
  },
  {
    path: "/invoiceList",
    name: "InvoiceList",
    component: () => import("../views/invoice/invoiceList/InvoiceList.vue"),
    meta: {
      needLogin: true,
      isLoginPage: false,
      navIndex: "100"
    }
  },
  {
    path: "/applyInvoice",
    name: "ApplyInvoice",
    component: () => import("../views/invoice/applyInvoice/ApplyInvoice.vue"),
    meta: {
      needLogin: true,
      isLoginPage: false,
      navIndex: "100"
    }
  },
  {
    path: "/newApplyInvoice",
    name: "NewApplyInvoice",
    component: () =>
      import("../views/invoice/newApplyInvoice/NewApplyInvoice.vue"),
    meta: {
      needLogin: true,
      isLoginPage: false,
      navIndex: "100"
    }
  },
  {
    path: "/invoiceDetail",
    name: "InvoiceDetail",
    component: () => import("../views/invoice/invoiceDetail/InvoiceDetail.vue"),
    meta: {
      needLogin: true,
      isLoginPage: false,
      navIndex: "100"
    }
  },
  {
    path: "/examRecord",
    name: "ExamRecord",
    component: () => import("../views/exam/examRecord/ExamRecord.vue"),
    meta: {
      needLogin: true,
      isLoginPage: false,
      navIndex: "100"
    }
  },
  {
    path: "/userProtocol",
    name: "UserProtocol",
    component: () => import("../views/privacy/UserProtocol.vue"),
    meta: {
      needLogin: false,
      isLoginPage: false,
      navIndex: "100"
    }
  },
  {
    path: "/privacy",
    name: "Privacy",
    component: () => import("../views/privacy/Privacy.vue"),
    meta: {
      needLogin: false,
      isLoginPage: false,
      navIndex: "100"
    }
  },
  {
    path: "/commonProblem",
    name: "CommonProblem",
    component: () => import("../views/commonProblem/CommonProblem.vue"),
    meta: {
      needLogin: true,
      isLoginPage: false,
      navIndex: "100"
    }
  }
];

const router = new VueRouter({
  routes
});

router.beforeEach((to, from, next) => {
  // TODO 测试用token
  // localStorage.removeItem("pc_user_token");
  // localStorage.removeItem("pc_user");
  // localStorage.setItem("pc_user_token", "22f3731541314d35a771cc1ebc9132b6");

  // TODO 微信审核用
  // if (to.path === "/regExam4wx") {
  //   localStorage.setItem("pc_user_token", "2a68dbcb6983491fbc08c40d23450bf2");
  //   localStorage.setItem(
  //     "pc_user",
  //     "{‘token': '2a68dbcb6983491fbc08c40d23450bf2'}"
  //   );
  // }

  //获取用户登录成功后储存的登录标志
  let userToken = localStorage.getItem("pc_user_token");

  //如果登录标志存在，即用户已登录
  if (userToken !== null && userToken !== undefined && userToken.length > 0) {
    //如果已登录，还想进入登录注册界面，则定向回首页
    if (to.meta.isLoginPage) {
      Message.success("您已登录");
      next({
        path: "/"
      });
    } else {
      next();
    }
  } else {
    // 如果登录标志不存在，即未登录

    // 用户想进入需要登录的页面，则定向回登录界面
    if (to.meta.needLogin) {
      next({
        path: "/login"
      });
      Message.error("请先登录");
      // 用户进入无需登录的界面，则跳转继续
    } else {
      next();
    }
  }
});

router.afterEach(to => {
  store.state.navIndex = to.meta && to.meta.navIndex ? to.meta.navIndex : "0";
  window.scroll(0, 0);
});

export default router;
